export const UPDATE_VIDEO_REF = 'UPDATE_VIDEO_REF'
export const UPDATE_RANGE_VALUE = 'UPDATE_RANGE_VALUE'
export const UPDATE_CURRENT_TIME = 'UPDATE_CURRENT_TIME'
export const TOGGLE_ANIMATION = 'TOGGLE_ANIMATION'
export const CLEAR_VIDEO = 'CLEAR_VIDEO'
